import { useTurboMutation } from "common/queries/hooks";

import { ClassifyAppointmentKindInput, ClassifyAppointmentKindResult } from "../types";
import { urls } from "./constants";

export const useClassifyApptMutation = ({
  onSuccess,
  onError,
}: { onSuccess?: (data: ClassifyAppointmentKindResult) => void; onError?: () => void } = {}) => {
  return useTurboMutation<ClassifyAppointmentKindInput, ClassifyAppointmentKindResult>({
    fetch: (body) => ({
      method: "POST",
      url: urls.classifyApptKind(),
      body,
    }),
    config: {
      onSuccess,
      onError,
    },
  });
};
